import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const AirportSelectorDropdownEl = styled(Div)`
    &&& {
      min-width: 100%;
      width: auto;
    }
`;
